<script>
export default {
    name: 'IconSearch',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-search"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M26 8c9.941 0 18 8.059 18 18 0 3.887-1.232 7.487-3.327 10.429l14.934 14.935-4.243 4.243-14.935-14.934A17.918 17.918 0 0126 44c-9.941 0-18-8.059-18-18S16.059 8 26 8zm0 7c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
